import * as yup from 'yup';

export const PoliticalPriceSchema = yup.object({
  price: yup.string().nullable(),
  preDiscount: yup.string().nullable(),
  referentialPrice: yup.string().nullable()
});
